'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const modalDialogHeader = "_modal-dialog-header_3xga1_1";
const styles = {
	modalDialogHeader: modalDialogHeader
};

const ModalDialogHeader = ({ children, className, style, textAlign = "start" }) => {
  return React__default.default.createElement(reactAriaComponents.Heading, { className: clsx__default.default(styles.modalDialogHeader, className), "data-text-align": textAlign, "data-zds": true, slot: "title", style }, children);
};

exports.ModalDialogHeader = ModalDialogHeader;
//# sourceMappingURL=Header.cjs.js.map
